import React from 'react';
import { Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import CalendarPrev from 'components/svg/prevCalendarButton.svg';
import CalendarNext from 'components/svg/nextCalendarButton.svg';
import IconButton from 'components/common/IconButton';

interface MobileCalendarHeaderProps {
  currentDate: Date;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onPrevYear: () => void;
  onNextYear: () => void;
}

const LABEL_COLOR = '#4E6DF5';

const MobileCalendarHeader: React.FC<MobileCalendarHeaderProps> = ({
  currentDate,
  onPrevMonth,
  onNextMonth,
  onPrevYear,
  onNextYear,
}) => {
  const monthLabel = format(currentDate, 'LLLL');
  const yearLabel = format(currentDate, 'yyyy');

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" px={1}>
      {/* Month navigation cluster */}
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <IconButton onClick={onPrevMonth} size="small">
          <CalendarPrev />
        </IconButton>
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: 1.2,
            color: LABEL_COLOR,
            minWidth: 90,
            textAlign: 'center',
          }}
        >
          {monthLabel}
        </Typography>
        <IconButton onClick={onNextMonth} size="small">
          <CalendarNext />
        </IconButton>
      </Stack>

      {/* Year navigation cluster */}
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <IconButton onClick={onPrevYear} size="small">
          <CalendarPrev />
        </IconButton>
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: 1.2,
            color: LABEL_COLOR,
            minWidth: 48,
            textAlign: 'center',
          }}
        >
          {yearLabel}
        </Typography>
        <IconButton onClick={onNextYear} size="small">
          <CalendarNext />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default MobileCalendarHeader;
